module.exports = __webpack_public_path__ + "img/jt-h2.356cca73.png";